import React from "react";
const NEON = "#00FF99";

export default function StaffingRisk({ loading, risk }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-semibold">Staffing Risk</h3>
        {!loading && <span className="text-xs text-white/60">Threshold {risk?.threshold ?? 80}%</span>}
      </div>
      {loading ? (
        <div className="space-y-2">
          {[...Array(4)].map((_,i)=><div key={i} className="h-10 rounded-xl border border-white/10 bg-white/5 animate-pulse" />)}
        </div>
      ) : (risk?.risky?.length || 0) === 0 ? (
        <p className="text-white/60 text-sm">No risky days in range.</p>
      ) : (
        <div className="space-y-2">
          {risk.risky.map((r,i)=>(
            <div key={i} className="p-2 rounded-xl border border-white/10 bg-black/30 text-sm flex items-center justify-between">
              <div className="text-white/80">{r.date}</div>
              <div className="text-white/70">{r.reason}</div>
              <div className="text-white/90 font-semibold" style={{ color: NEON }}>{r.staffingPct}%</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
